import { render, staticRenderFns } from "./IndexWithDrag.vue?vue&type=template&id=782a0e23&scoped=true"
import script from "./IndexWithDrag.vue?vue&type=script&lang=js"
export * from "./IndexWithDrag.vue?vue&type=script&lang=js"
import style0 from "./IndexWithDrag.vue?vue&type=style&index=0&id=782a0e23&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782a0e23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('782a0e23')) {
      api.createRecord('782a0e23', component.options)
    } else {
      api.reload('782a0e23', component.options)
    }
    module.hot.accept("./IndexWithDrag.vue?vue&type=template&id=782a0e23&scoped=true", function () {
      api.rerender('782a0e23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/viewSelect/IndexWithDrag.vue"
export default component.exports